import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BudgetStatusesModel } from 'src/common';
import { environment } from 'src/environments/environment';

const localApiUrl = `${environment.apiUrl}/BudgetStatuses`;

@Injectable()
export class BudgetStatusesService {

  constructor(private http: HttpClient) { }
  getAll(): Promise<BudgetStatusesModel[]> {
    return this.http.get<BudgetStatusesModel[]>(`${localApiUrl}/All`).toPromise();
  }

}
